// Record tool (moved from the control bar into the Meeting Tools panel). This
// is unchanged local recording (F-REC): it captures the meeting to a file on
// the host's own device, and everyone is notified via the always-visible REC
// indicator (RecordingIndicator, untouched). This view only starts/stops and
// reflects state — no new mechanism, no video-path work.

import { memo, useCallback } from 'react';

import { recordingSupported, startRecording, stopRecording } from '../../recording';
import { callStore, useCallStore } from '../../store/callStore';
import { IconRecord } from '../../ui/icons';

export const RecordTool = memo(function RecordTool() {
  const recording = useCallStore((s) => s.recordingLocally);
  const allowed = useCallStore((s) => s.recordingAllowed);
  const supported = recordingSupported();

  const toggle = useCallback(() => {
    if (callStore.getState().recordingLocally) void stopRecording();
    else void startRecording();
  }, []);

  if (!allowed) {
    return <p className="bz-mt-note">Recording is turned off for this workspace.</p>;
  }
  if (!supported) {
    return (
      <p className="bz-mt-note">
        Recording isn&rsquo;t supported in this browser. Use a current Chrome or Edge.
      </p>
    );
  }

  return (
    <div className="bz-mt-record">
      <p className="bz-mt-note">
        Captures this meeting to a file on your device. Everyone is notified with a recording
        indicator while it runs, and your recording stops if you leave the call.
      </p>
      <button
        type="button"
        className={`bz-mt-record-btn${recording ? ' is-recording' : ''}`}
        onClick={toggle}
      >
        <IconRecord size={18} />
        {recording ? 'Stop recording' : 'Start recording'}
      </button>
      {recording && (
        <p className="bz-mt-record-live">
          <span className="bz-mt-rec-dot" aria-hidden="true" />
          Recording in progress
        </p>
      )}
    </div>
  );
});
